<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-code-select
              ref="codeSelectCompanyCode"
              v-model="userBasic.companyCode"
              codeId="COD_ITGR_CPNY"
              :defaultOption="'select'"
            />
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldDepartmentName"
              v-model="userBasic.departmentName"
              maxlength="400"
              @keyup.enter="onClickDeptSearch"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickDeptSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_NAME')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldUserName"
              v-model="userBasic.userName"
              maxlength="400"
            />
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_ENG_NAME')"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldUserGlobalName"
              v-model="userBasic.userGlobalName"
              maxlength="400"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_LOGIN_ID')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            {{ userBasic.loginId }}
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_EMAIL')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldEmail"
              v-model="userBasic.email"
              maxlength="100"
            />
            <sui-button
              type="button"
              class="comm_btn_duplicate"
              :disabled="emailEqual"
              @click="onEmailDuplicateCheckClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_PW')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldPassword"
              v-model="password"
              :password="true"
              maxlength="100"
            />
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_PW_CHECK')"
              :required="true"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldPasswordCheck"
              v-model="passwordChkText"
              :password="true"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_EPNO')"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldEmployeeIDNumber"
              v-model="userBasic.employeeIDNumber"
              maxlength="30"
            />
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_CRLV')"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-code-select
              ref="codeSelectcareerLevelCode"
              v-model="userBasic.careerLevelCode"
              codeId="COD_CRLV"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_CP')"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldCellphone"
              v-model="userBasic.cellphone"
              maxlength="40"
            />
          </div>
          <div class="col-xs-1 ">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_CONTA')"
            />
          </div>
          <div class="col-xs-5 ">
            <sui-text-field
              ref="textFieldCompanyContactAddr"
              v-model="userBasic.companyContactAddr"
              maxlength="200"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onClickSave"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00020', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      queryData: {},
      customOptions: {
      },
      userBasic: {
        companyCode: '',
        companyName: '',
        companyEnglishName: '',
        departmentId: '',
        departmentName: '',
        departmentEnglishName: '',
        careerLevelCode: '',
        careerLevelName: '',
        careerLevelEnglishName: '',
        cellphone: '',
        companyContactAddr: '',
        publicIdYn: '',
        userId: '',
        loginId: '',
        epid: '',
        employeeIDNumber: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        email: '',
        empInfoFinalChangeDT: '',
        userRealityUseYn: '',
        userTypeCode: '',
        userBelongingTypeCode: '',
        servedStateCode: '',
        displayLangId: '',
      },
      password: '',
      passwordChkText: '',
      originEmail: '',
    };
  },
  computed: {
    session() {
      return this.$store.getters.userInfo;
    },
    emailEqual() {
      return utils.isEqual(this.userBasic.email, this.originEmail);
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.session.userId)) {
        this.onLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      http.request(this.contextPageId, 'DTS_CMP_00072', {
        path: {
          'user-id': this.session.userId,
        },
      }).then(res => {
        this.userBasic = utils.clone(res.data);
        this.originEmail = this.userBasic.email;
      }).catch(error => {
        console.log(error);
      });
    },
    onClickCancel() {
      this.closePagePopup('');
    },
    onClickSave() {
      if (!this.validateUserData()) {
        return false;
      }
      this.validateUserPassword().then(() => {
        this.saveAction();
      }).catch(err => {
        console.log(err);
      });
      return true;
    },
    saveAction() {
      this.userBasic.empInfoFinalChangeDT = utils.now('YYYYMMDD');
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.contextPageId, 'DTS_CMP_00070', {
          data: this.userBasic,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.closePagePopup(true);
        });
      });
      return true;
    },
    validateUserData() {
      if (utils.isEmpty(utils.trim(this.userBasic.companyCode))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CPNY')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.userBasic.departmentId))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DEPT')));
        return false;
      }
      if (utils.isEmpty(this.userBasic.userName)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_NAME')), null, () => {
          this.$refs.textFieldUserName.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.userBasic.email)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_EMAIL')), null, () => {
          this.$refs.textFieldEmail.setFocus();
        });
        return false;
      }
      if (!this.emailEqual) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DUP'), null, () => {
        });
        return false;
      }
      if (utils.isEmpty(this.password)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PW')), null, () => {
          this.$refs.textFieldPassword.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.passwordChkText)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PW_CHECK')), null, () => {
          this.$refs.textFieldPasswordCheck.setFocus();
        });
        return false;
      }
      if (!utils.isEqual(this.password, this.passwordChkText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_PW_NOT_MATCH'), null, () => {
          this.$refs.textFieldPasswordCheck.setFocus();
        });
        return false;
      }
      return true;
    },
    validateUserPassword() {
      return new Promise((resolve, reject) => {
        const dataParams = {
          userPasswordValue: this.password,
        };
        http.request(this.contextPageId, 'DTS_CMP_00076', {
          path: {
            'user-id': this.session.userId,
          },
          data: dataParams,
        }).then(res => {
          if (res.data <= 0) {
            utils.messageBox('error', this.$t('MSG_ALT_PW_INCORRECT'));
            reject();
          }
          resolve();
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    },
    onClickDeptSearch() {
      const iptDeptName = this.userBasic.departmentName;
      utils.openLayerPopup('PGE_CMY_00004', this.onDeptPopupCallback, {
        pageInitialData: { iptDeptName },
        size: 'lg',
      });
    },
    onDeptPopupCallback(data) {
      if (data) {
        this.userBasic.departmentName = data.value;
        this.userBasic.departmentId = data.id;
      }
    },
    onEmailDuplicateCheckClick() {
      if (utils.isEmpty(utils.trim(this.userBasic.email))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_EMAIL')));
        return false;
      }
      http.request(this.contextPageId, 'DTS_CMP_00074', {
        query: {
          email: this.userBasic.email,
        },
      }).then(res => {
        if (res.data > 0) {
          utils.messageBox('error', this.$t('MSG_ALT_DUPLICATE_EXISTS'));
        } else {
          utils.messageBox('success', utils.strFormat(this.$t('MSG_ALT_BE_RGST_OK'), this.$t('MSG_TXT_EMAIL')));
          this.originEmail = this.userBasic.email;
        }
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
  },
};
</script>

<style scoped>
</style>
